'use strict';
import * as $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dAccepted$002dDrug$002dRequest$002dNeeds$002dAttention from "./app.api.-Pharmacy-App-Update$-Accepted-Drug-Request-Needs-Attention.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
/** @constructor */
function $c_Lapp_api_PharmacyAppUpdate$$anon$121() {
}
export { $c_Lapp_api_PharmacyAppUpdate$$anon$121 as $c_Lapp_api_PharmacyAppUpdate$$anon$121 };
$c_Lapp_api_PharmacyAppUpdate$$anon$121.prototype = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$h_O();
$c_Lapp_api_PharmacyAppUpdate$$anon$121.prototype.constructor = $c_Lapp_api_PharmacyAppUpdate$$anon$121;
/** @constructor */
function $h_Lapp_api_PharmacyAppUpdate$$anon$121() {
}
export { $h_Lapp_api_PharmacyAppUpdate$$anon$121 as $h_Lapp_api_PharmacyAppUpdate$$anon$121 };
$h_Lapp_api_PharmacyAppUpdate$$anon$121.prototype = $c_Lapp_api_PharmacyAppUpdate$$anon$121.prototype;
$c_Lapp_api_PharmacyAppUpdate$$anon$121.prototype.compose__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__compose__F1__F1(this, g);
});
$c_Lapp_api_PharmacyAppUpdate$$anon$121.prototype.andThen__F1__F1 = (function(g) {
  return $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$f_F1__andThen__F1__F1(this, g);
});
$c_Lapp_api_PharmacyAppUpdate$$anon$121.prototype.toString__T = (function() {
  return "<function1>";
});
$c_Lapp_api_PharmacyAppUpdate$$anon$121.prototype.apply__Lapp_api_PharmacyAppUpdate__Z = (function(a) {
  return ((a instanceof $j_app$002eapi$002e$002dPharmacy$002dApp$002dUpdate$0024$002dAccepted$002dDrug$002dRequest$002dNeeds$002dAttention.$c_Lapp_api_PharmacyAppUpdate$AcceptedDrugRequestNeedsAttention) && (a !== null));
});
$c_Lapp_api_PharmacyAppUpdate$$anon$121.prototype.apply__O__O = (function(v1) {
  return this.apply__Lapp_api_PharmacyAppUpdate__Z(v1);
});
$c_Lapp_api_PharmacyAppUpdate$$anon$121.prototype.apply$mcZI$sp__I__Z = (function(v1) {
  return this.apply__Lapp_api_PharmacyAppUpdate__Z(v1);
});
var $d_Lapp_api_PharmacyAppUpdate$$anon$121 = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().initClass($c_Lapp_api_PharmacyAppUpdate$$anon$121, "app.api.PharmacyAppUpdate$$anon$121", ({
  Lapp_api_PharmacyAppUpdate$$anon$121: 1,
  F1: 1,
  Ljava_io_Serializable: 1,
  Lmagnolia1_SerializableFunction1: 1
}));
export { $d_Lapp_api_PharmacyAppUpdate$$anon$121 as $d_Lapp_api_PharmacyAppUpdate$$anon$121 };
//# sourceMappingURL=app.api.-Pharmacy-App-Update$$anon$121.js.map
